// For logged-out users, redirect to sign in before Swym can act. We listen in
// the capture phase so this runs ahead of Swym's own button click handler.
document.addEventListener(
  "click",
  function (event) {
    const wrapper = event.target.closest(".fp-follow-icon-button");
    if (!wrapper) return;
    // Prevent users who aren't logged in from following
    // Sends them to sign in page immediately
    if (window.isLoggedIn === false) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = getLoginUrl();
    }
  },
  true,
);

document.addEventListener(
  "click",
  async function (event) {
    const userAgent = navigator.userAgent;
    const isMobileApp = userAgent.includes("XFPAPP") || userAgent.includes("ShopifyCheckoutSDK");
    const checkoutBtn = event.target.closest('[data-event-source="checkout"]');
    if (checkoutBtn) {
      event.preventDefault();
      event.stopImmediatePropagation();
      try {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attributes: { is_mobile_app: isMobileApp ? "true" : "false" },
          }),
        });
      } catch (error) {
        console.error("Failed to update cart:", error);
      } finally {
        window.location.href = "/checkout?skip_shop_pay=true";
      }
    }
    const addToBagBtn = event.target.closest("button.fp-following-add-to-bag");
    if (addToBagBtn) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (addToBagBtn.disabled || addToBagBtn.classList.contains("disabled")) {
        return;
      }
      addToBagBtn.disabled = true;
      addToBagBtn.classList.add("disabled");

      const parentForm = addToBagBtn.closest("form");
      if (parentForm) {
        parentForm.addEventListener("submit", (e) => e.preventDefault(), { once: true });
      }
      const parentAnchor = addToBagBtn.closest("a");
      if (parentAnchor) {
        parentAnchor.removeAttribute("href");
        parentAnchor.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
          },
          { once: true },
        );
      }
      const variantId = addToBagBtn.closest("div")?.querySelector('input[name="id"]')?.value;
      const productId = addToBagBtn.getAttribute("data-product-id");
      const productUrl = addToBagBtn.getAttribute("data-product-url");
      if (!variantId) return;
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        const sectionsRes = await fetch("/cart?sections=cart-drawer,cart-icon-bubble,cart-drawer-items");
        const parsedState = await sectionsRes.json();
        // Add to swym queue.
        if (variantId && productId && productUrl) {
          processAddingItem({
            epi: variantId,
            empi: productId,
            du: productUrl,
            qty: 1,
          });
        }

        window.dispatchEvent(new Event("refresh-cart-drawer"));
        addToBagBtn.classList.add("disabled");
        addToBagBtn.setAttribute("disabled", "true");
        addToBagBtn.innerText = "Added to Bag";
        cartItems.push(variantId);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "quick-add",
          cartData: parsedState,
        });
      } catch (err) {
        console.error("Add to cart failed:", err);
        captureErrorWithScope(err, {
          area: "cart",
          action: "add-to-cart",
        });
      }
      return;
    }
  },
  { capture: true },
);

const placeholder =
  (typeof window !== "undefined" && window.knotPlaceholderImage) ||
  "https://cdn.shopify.com/s/files/1/0894/3186/7695/files/content-placeholder-image.svg";
const INVALID_IMAGE_URLS = ["http://cdn.shopify.com/s/images/admin/no-image-compact.gif"];

const INJECTED_CARD_CONDITION_LABEL_OVERRIDES = { "Shows Wear": "Very Good", Worn: "Good" };

function isValidImage(url) {
  return url && typeof url === "string" && !INVALID_IMAGE_URLS.some((invalidUrl) => url.includes(invalidUrl));
}

function pickImage(imageOptions) {
  return imageOptions.find(isValidImage) || placeholder;
}

const productCache = {};

/**
 * Fetch with retry logic and exponential backoff
 * @param {string} url - URL to fetch
 * @param {number} retries - Number of retries (default: 3)
 * @param {number} baseDelay - Base delay in ms (default: 1000)
 * @returns {Promise<Response>}
 */
async function fetchWithRetry(url, retries = 3, baseDelay = 1000) {
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const res = await fetch(url);
      if (res.status === 404) return null;
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res;
    } catch (err) {
      if (attempt === retries) throw err;
      const delay = baseDelay * Math.pow(2, attempt);
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }
}

const MAX_CONCURRENT_PRODUCT_FETCHES = 6;
let activeProductFetches = 0;
const productFetchQueue = [];

function runNextProductFetch() {
  if (activeProductFetches >= MAX_CONCURRENT_PRODUCT_FETCHES) return;
  const job = productFetchQueue.shift();
  if (!job) return;
  activeProductFetches++;
  fetchWithRetry(`/products/${job.handle}.js`)
    .then((res) => (res ? res.json() : null))
    .catch((err) => {
      console.error(`Could not load product "${job.handle}" after retries`, err);
      return null;
    })
    .then((product) => {
      activeProductFetches--;
      if (product == null) delete productCache[job.handle];
      job.resolve(product);
      runNextProductFetch();
    });
}

function fetchProduct(handle) {
  if (!handle) {
    console.warn("fetchProduct called without a handle:", handle);
    return Promise.resolve(null);
  }
  if (productCache[handle]) return productCache[handle];
  const promise = new Promise((resolve) => {
    productFetchQueue.push({ handle, resolve });
    runNextProductFetch();
  });
  productCache[handle] = promise;
  return promise;
}

function prioritizeProduct(handle) {
  if (!handle) return;
  const idx = productFetchQueue.findIndex((job) => job.handle === handle);
  if (idx > 0) {
    const [job] = productFetchQueue.splice(idx, 1);
    productFetchQueue.unshift(job);
  }
}

function updateImageElement(selector, url) {
  const imgElement = document.querySelector(selector);
  if (imgElement) imgElement.src = url;
}

const TARGET_IMAGE_SIZE = "376";

function resizeImage(url) {
  const normalized = url.startsWith("//") ? `https:${url}` : url;
  const parsed = new URL(normalized, location.origin);
  if (!parsed) return url;
  parsed.searchParams.set("width", TARGET_IMAGE_SIZE);
  parsed.searchParams.set("height", TARGET_IMAGE_SIZE);
  parsed.searchParams.set("crop", "center");
  parsed.searchParams.set("format", "webp");
  const resizedUrl = parsed.toString();
  return resizedUrl;
}
function getPrimaryImage(product) {
  const imageOptions = [
    product.image,
    product.featured_image,
    product?.featured_media?.src,
    product?.images?.[0],
    product?.media?.[0]?.src,
  ];
  const fallbackImage = pickImage(imageOptions);
  const initialImage = fallbackImage === placeholder ? fallbackImage : resizeImage(fallbackImage);
  fetchProduct(product.handle).then((shopifyProduct) => {
    const canonical = shopifyProduct?.images?.[0];
    if (!canonical) return;
    const primaryImage = resizeImage(canonical);
    if (primaryImage !== initialImage) {
      updateImageElement(`img[variant="${product.variant}"]`, primaryImage);
    }
  });

  return initialImage;
}

function getSecondaryImageByProduct(product) {
  if (!product || !product.handle) {
    return null;
  }

  const imageOptions = [product?.images?.[1], product?.media?.[1]?.src, product?.alt_images?.[1]];
  const fallbackImage = pickImage(imageOptions);
  const initialImage = fallbackImage === placeholder ? fallbackImage : resizeImage(fallbackImage);
  fetchProduct(product.handle).then((shopifyProduct) => {
    const canonical = shopifyProduct?.images?.[1];
    if (!canonical) return;
    const secondaryImage = resizeImage(canonical);
    if (secondaryImage !== initialImage) {
      updateImageElement(`img.fp-injected-secondary-image[data-product-handle="${product.handle}"]`, secondaryImage);
    }
  });
  return initialImage;
}

// Each slide is wrapped in a link to the product so right-click / long-press offers
// "Open link in new tab". The card title link remains the accessible link, so these
// are hidden from assistive tech and the tab order.
function buildCarouselSlidesHTML(images, alt, href) {
  const allUrls = [images[images.length - 1], ...images, images[0]];
  return allUrls
    .map((url, i) => {
      const isClone = i === 0 || i === allUrls.length - 1;
      const img = `<img class="fp-mobile-carousel__slide" src="${url}" alt="${alt}" loading="lazy" draggable="false"${isClone ? ' aria-hidden="true"' : ""}>`;
      return href
        ? `<a class="fp-mobile-carousel__slide-link" href="${href}" tabindex="-1" aria-hidden="true" draggable="false">${img}</a>`
        : img;
    })
    .join("");
}

function processCardForCarousel(card) {
  if (card.dataset.carouselProcessed) return;
  card.dataset.carouselProcessed = "true";

  // Skip carousel on Saved Search cards
  if (card.closest(".fp-saved-search-wrapper")) return;

  const handle = card.dataset.handle;
  if (!handle) return;

  const wrapper = card.querySelector(".fp-image-badge-wrapper");
  if (!wrapper) return;

  const productUrl = card.querySelector("a.fp-card__link")?.getAttribute("href");

  fetchProduct(handle).then((shopifyProduct) => {
    if (!shopifyProduct?.images?.length || shopifyProduct.images.length < 2) return;

    const images = shopifyProduct.images.slice(0, MAX_CAROUSEL_IMAGES).map(resizeImage);
    const slideCount = images.length;
    const alt = shopifyProduct.title || "";

    const slidesHTML = buildCarouselSlidesHTML(images, alt, productUrl);

    const container = document.createElement("div");
    container.className = "fp-mobile-carousel-container";
    container.innerHTML = `<div class="fp-mobile-carousel" data-handle="${handle}" data-slide-count="${slideCount}">
      <div class="fp-mobile-carousel__track">${slidesHTML}</div>
    </div>
    <div class="fp-mobile-carousel__indicator">
      <div class="fp-mobile-carousel__indicator-active" style="width: ${100 / slideCount}%"></div>
    </div>`;

    // Hide the original static image wrapper on mobile so carousel is visible and interactive
    const imageWrapper = wrapper.querySelector(".fp-image-wrapper");
    if (imageWrapper) {
      imageWrapper.classList.add("fp-hidden-for-carousel");
    }

    const badges = wrapper.querySelector(".fp-injected-badges");
    if (badges) {
      wrapper.insertBefore(container, badges);
    } else {
      wrapper.appendChild(container);
    }

    const carousel = container.querySelector(".fp-mobile-carousel");
    if (carousel) initCarousel(carousel);
  });
}

function processCardProductForCarousel(card) {
  if (card.dataset.carouselProcessed) return;
  card.dataset.carouselProcessed = "true";

  // Extract handle from the product URL in the card link
  const link = card.querySelector("a.fp-card__link");
  if (!link) return;
  const href = link.getAttribute("href");
  if (!href) return;
  const handle = href.split("/products/")[1]?.split("?")[0];
  if (!handle) return;

  const mediaWrapper = card.querySelector(".card__media");
  if (!mediaWrapper) return;

  fetchProduct(handle).then((shopifyProduct) => {
    if (!shopifyProduct?.images?.length || shopifyProduct.images.length < 2) return;

    const images = shopifyProduct.images.slice(0, MAX_CAROUSEL_IMAGES).map(resizeImage);
    const slideCount = images.length;
    const alt = shopifyProduct.title || "";

    const slidesHTML = buildCarouselSlidesHTML(images, alt, href);

    const container = document.createElement("div");
    container.className = "fp-mobile-carousel-container";
    container.innerHTML = `<div class="fp-mobile-carousel" data-handle="${handle}" data-slide-count="${slideCount}">
      <div class="fp-mobile-carousel__track">${slidesHTML}</div>
      <div class="fp-mobile-carousel__indicator">
        <div class="fp-mobile-carousel__indicator-active" style="width: ${100 / slideCount}%"></div>
      </div>
    </div>`;

    // Hide the original media wrapper on mobile so carousel is visible
    const hoverMedia = mediaWrapper.querySelector(".media--hover-effect");
    if (hoverMedia) {
      hoverMedia.classList.add("fp-hidden-for-carousel");
    }

    // Elevate card__media above the stretch link overlay (z-index: 1 on .card__heading a::after)
    mediaWrapper.style.zIndex = "2";

    mediaWrapper.insertBefore(container, mediaWrapper.firstChild);

    // Elevate the badge above the carousel without blocking swipe
    const badgeWrapper = card.querySelector(".card__inner > .card__content");
    if (badgeWrapper) {
      badgeWrapper.style.position = "relative";
      badgeWrapper.style.zIndex = "3";
      badgeWrapper.style.pointerEvents = "none";
    }

    const carousel = container.querySelector(".fp-mobile-carousel");
    if (carousel) initCarousel(carousel);

    // Prevent the card's onclick="location.href=..." from firing during swipes
    const cardInner = card.querySelector(".card__inner[onclick]");
    if (cardInner) {
      let cardTouchStartX = 0;
      let cardIsSwiping = false;

      cardInner.addEventListener(
        "touchstart",
        (e) => {
          cardTouchStartX = e.touches[0].clientX;
          cardIsSwiping = false;
        },
        { passive: true },
      );

      cardInner.addEventListener(
        "touchmove",
        (e) => {
          if (Math.abs(e.touches[0].clientX - cardTouchStartX) > SWIPE_THRESHOLD_PX) {
            cardIsSwiping = true;
          }
        },
        { passive: true },
      );

      // Replace the inline onclick with a guarded version
      const originalHref = cardInner.getAttribute("onclick").match(/location\.href='([^']+)'/)?.[1];
      if (originalHref) {
        cardInner.removeAttribute("onclick");
        cardInner.addEventListener("click", (e) => {
          // Carousel slides are real links now; let the browser navigate them
          if (e.target.closest("a[href]")) return;
          if (!cardIsSwiping) {
            location.href = originalHref;
          }
          cardIsSwiping = false;
        });
      }
    }
  });
}

function injectCTA(product, hasHoldStatus, isInCart) {
  fetchProduct(product.handle).then((shopifyProduct) => {
    const isProductSoldOut = !shopifyProduct?.available;

    const wrapper = document.querySelector(
      `.fp-following-add-to-bag-btn-wrapper[data-product-handle="${product.handle}"]`,
    );

    if (!wrapper) return;

    const findAnotherButton = `
      <a href="/search?q=${product.title}"
        title="Search for ${product.title}"
        class="button button--full-width fp-following-add-to-bag fp-find-another-button"
      >Find Another</a>`;

    const productInBagWarning = `
      <button
        aria-label="Added to Bag"
        class="button button--full-width fp-following-add-to-bag disabled"
        type="submit"
        disabled
      >
        Added to Bag
      </button>`;

    const addToBagButton = `
      <form method="post" action="/cart/add" id="fp-following-add-to-bag-${product.variant}">
        <input type="hidden" name="id" value="${product.variant}" />
        <button
          aria-label="Add to Bag"
          type="submit"
          data-variant-id="${product.variant}"
          data-product-id="${product.id}"
          data-product-url="${product.url}"
          ${hasHoldStatus ? "disabled" : ""}
          class="button button--full-width fp-following-add-to-bag ${hasHoldStatus ? "disabled" : ""}"
        >Add to Bag</button>
      </form>`;

    if (isProductSoldOut || hasHoldStatus) {
      wrapper.innerHTML = findAnotherButton;
    } else if (isInCart) {
      wrapper.innerHTML = productInBagWarning;
    } else {
      wrapper.innerHTML = addToBagButton;
    }
  });
}

function injectBadges(product, algoliaData, html = null) {
  const useHTML = typeof html === "function";
  const wrap = (strings, ...values) =>
    useHTML ? html(strings, ...values) : strings.reduce((acc, str, i) => acc + str + (values[i] ?? ""), "");
  const badgesConfig = window.badgeConfig;
  const badgeColorScheme = badgesConfig.color_schemes;

  const comingSoonHoldStatuses = ["coming soon", "inventory transfer"];
  const holdStatusInProduct = product?.hold_status || "None";
  const isHoldStatusComingSoon = comingSoonHoldStatuses.includes(holdStatusInProduct.toLowerCase());
  const isHoldStatusRetailValue = holdStatusInProduct.toLowerCase() === "retail active";
  const currentUrl = window.location.href;
  const isFollowingPage = currentUrl.includes("following");
  const customMeta = algoliaData?.meta?.custom;
  const holdStatus = customMeta?.hold_status || "None";
  const isProductHoldStatusRetailValue = holdStatus?.toLowerCase() === "retail active";
  const isProductHoldStatusComingSoon = comingSoonHoldStatuses.includes(holdStatus?.toLowerCase());

  // isProductHoldStatusRetailValue data comes from algolia; isHoldStatusRetailValue data comes from shopify
  if (isProductHoldStatusRetailValue || isHoldStatusRetailValue) {
    return wrap`<span
      class="fp-badge-retail-active badge price__badge-hold-status color-${badgeColorScheme.hold_status}"
      data-product-handle="${product.handle}"
    >Call to Enquire</span>`;
  }

  if (isProductHoldStatusComingSoon || isHoldStatusComingSoon) {
    return wrap`<span class="badge price__badge-hold-status color-${badgeColorScheme.hold_status}">Coming Soon</span>`;
  }

  if (isFollowingPage) {
    fetchProduct(product.handle).then((shopifyProduct) => {
      if (shopifyProduct?.available === undefined) return;
      const isProductSoldOut = !shopifyProduct?.available;
      if (!isProductSoldOut) return;

      const soldOutBadgeHTML = `<span class="badge price__badge-sold-out color-${badgeColorScheme.sold_out}">Sold Out</span>`;

      const badgesWrapper = document.querySelector(`.fp-injected-badges[data-product-handle="${product.handle}"]`);
      if (badgesWrapper) {
        badgesWrapper.innerHTML = soldOutBadgeHTML;
      }

      const priceWrapper = document.querySelector(`.price.price--on-sale[data-product-handle="${product.handle}"]`);
      if (priceWrapper) {
        priceWrapper.style.display = "none";
      }
    });
  }

  return "";
}

function shouldHandleCartUpdateOnFollowingPage(event) {
  return Boolean(event?.variantId) && window.location.href.includes("following");
}

// Re-enable "Add to Bag" buttons on the following page when it's are removed from the cart
subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  if (!shouldHandleCartUpdateOnFollowingPage(event)) return;

  const variantId = String(event.variantId);

  // Check if it's still there in the cart after the update
  const items = event.cartData?.items;
  const stillInCart =
    Array.isArray(items) &&
    items.some((item) => String(item.variant_id) === variantId || String(item.id) === variantId);

  if (stillInCart) return;

  const btn = document.querySelector(`button.fp-following-add-to-bag[data-variant-id="${variantId}"]`);
  if (btn) {
    btn.disabled = false;
    btn.classList.remove("disabled");
    btn.innerText = "Add to Bag";
    btn.setAttribute("aria-label", "Add to Bag");
  }

  if (Array.isArray(window.cartItems)) {
    const index = window.cartItems.indexOf(variantId);
    if (index > -1) {
      window.cartItems.splice(index, 1);
    }
  }
});

function tokenizeSaleMessage(text) {
  // Regex to detect asterisks
  const regex = /\*(.+?)\*/g;
  const tokens = [];
  let lastIndex = 0;
  let match;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      tokens.push({ type: "text", value: text.slice(lastIndex, match.index) });
    }
    tokens.push({ type: "bold", value: match[1] });
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    tokens.push({ type: "text", value: text.slice(lastIndex) });
  }
  return tokens;
}

function renderSaleMessage(wrap, text) {
  const tokens = tokenizeSaleMessage(text);
  const strings = [];
  const values = [];
  let currentString = "";
  for (const token of tokens) {
    if (token.type === "text") {
      strings.push(currentString);
      values.push(token.value);
      currentString = "";
    } else {
      strings.push(currentString + `<span class="fp-font-weight--semibold">`);
      values.push(token.value);
      currentString = `</span>`;
    }
  }
  strings.push(currentString);
  strings.raw = strings;
  return wrap(strings, ...values);
}

function renderInjectedProductCard(product, onClick, algoliaData, html = null) {
  const useHTML = typeof html === "function";
  const wrap = (strings, ...values) =>
    useHTML ? html(strings, ...values) : strings.reduce((acc, str, i) => acc + str + (values[i] ?? ""), "");
  const badgesConfig = window.badgeConfig;

  const holdStatusInProduct = product?.hold_status || "None";
  const isHoldStatusComingSoon = holdStatusInProduct.toLowerCase() === "coming soon";
  const isProductSoldOut = product?.inventory_quantity < 1;
  const cartItems = window.cartItems || [];
  const isInCart = cartItems.includes(product.variant);
  const currentUrl = window.location.href;
  const isFollowingPage = currentUrl.includes("following");
  const customMeta = algoliaData?.meta?.custom;
  const holdStatus = customMeta?.hold_status || "None";
  const isProductHoldStatusRetailValue = holdStatus?.toLowerCase() === "retail active";
  const isProductHoldStatusComingSoon = holdStatus?.toLowerCase() === "coming soon";
  const hasHoldStatus = holdStatus && holdStatus !== "None";
  const isLoggedIn = window.isLoggedIn;
  const price = product.market_pricing_gbp?.price || product.price || 0;
  const compareAtPrice = product.market_pricing_gbp?.compare_at_price || product.compare_at_price || 0;
  const currency = window.algoliaShopify.helpers.activeCurrencyCode();
  const currencySymbol = currency === "gbp" ? "£" : "$";
  const retailSavings = parseFloat(customMeta?.retail_savings || product?.retail_savings) || 0;
  const retailPercentOff = Math.round(retailSavings);
  const retailPrice = retailSavings > 0 ? Math.round(price / (1 - retailSavings / 100)) : 0;
  const salePercentOff = compareAtPrice > price ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100) : 0;
  const saleMessageConfig = window.saleMessageConfig || {};
  const saleCollectionIds = (algoliaData?.collection_ids || []).map(String);
  const saleMessage =
    saleMessageConfig.collection_id &&
    saleMessageConfig.text &&
    saleCollectionIds.includes(String(saleMessageConfig.collection_id))
      ? saleMessageConfig.text
      : null;

  const hasAnyHoldStatus = holdStatusInProduct.toLowerCase() !== "none" || holdStatus.toLowerCase() !== "none";

  const shouldHidePrice = isProductSoldOut || hasAnyHoldStatus;

  const findAnotherButton = wrap`<div class="fp-following-add-to-bag-btn-wrapper">
    <a href="/search?q=${product.title}"
      title="Search for ${product.title}"
      class="button button--full-width fp-following-add-to-bag fp-find-another-button"
    >Find Another</a>
  </div>`;

  const addToBagButton = wrap`<div class="fp-following-add-to-bag-btn-wrapper">
    <form method="post" action="/cart/add" id="fp-following-add-to-bag-${product.variant}">
      <input type="hidden" name="id" value="${product.variant}" />
      <button
        aria-label="Add to Bag"
        type="submit"
        data-variant-id="${product.variant}"
        data-product-id="${product.id}"
        data-product-url="${product.url}"
        ${hasHoldStatus ? "disabled" : ""}
        class="button button--full-width fp-following-add-to-bag ${hasHoldStatus ? "disabled" : ""}"
      >Add to Bag</button>
    </form>
  </div>`;

  const productInBagWarning = wrap`<div class="fp-following-add-to-bag-btn-wrapper">
    <button
      aria-label="Added to Bag"
      type="submit"
      disabled
      class="button button--full-width fp-following-add-to-bag disabled"
    >
      Added to Bag
    </button>
  </div>`;

  const wishlistButton = useHTML
    ? isFollowingPage
      ? wrap`<div class="fp-follow-buttons-wrapper">
          <input
            id="product-card-edit--${product.id}"
            class="fp-following-checkbox"
            type="checkbox"
            name="select product"
            data-product-id="${product.id}"
            data-variant-id="${product.variant}"
            data-product-url="${product.url}"
          />
          <div class="fp-follow-icon-button">
            <button
              aria-label="Add to Wishlist"
              name="add-to-wishlist"
              data-product-name="${product.title}"
              data-with-epi="true"
              class="swym-button swym-add-to-wishlist-view-product product_${product.id} swym-loaded swym-icon swym-heart"
              data-swaction="addToWishlist"
              data-product-id="${product.id}"
              data-variant-id="${product.variant}"
              data-product-url="${product.url}"
            ></button>
            <div class="fp-collections-social-count" data-product-id="${product.id}">${product?.social_count || ""}</div>
          </div>
        </div>`
      : wrap`<div class="fp-follow-icon-button">
          <button
            aria-label="Add to Wishlist"
            name="add-to-wishlist"
            data-product-name="${product.title}"
            data-with-epi="true"
            class="swym-button swym-add-to-wishlist-view-product product_${product.id} swym-loaded swym-icon swym-heart"
            data-swaction="addToWishlist"
            data-product-id="${product.id}"
            data-variant-id="${product.variant}"
            data-product-url="${product.url}"
            ${!isLoggedIn ? "data-no-user" : ""}
          ></button>
          <div class="fp-collections-social-count" data-product-id="${product.id}">${product?.social_count || ""}</div>
        </div>`
    : isFollowingPage
      ? `<div class="fp-follow-buttons-wrapper">
        <input
          id="product-card-edit--${product.id}"
          class="fp-following-checkbox"
          type="checkbox"
          name="select product"
          data-product-id="${product.id}"
          data-variant-id="${product.variant}"
          data-product-url="${product.url}"
        />
        <div class="fp-follow-icon-button">
          <button
            aria-label="Add to Wishlist"
            name="add-to-wishlist"
            data-product-name="${product.title}"
            data-with-epi="true"
            class="swym-button swym-add-to-wishlist-view-product product_${product.id} swym-loaded swym-icon swym-heart"
            data-swaction="addToWishlist"
            data-product-id="${product.id}"
            data-variant-id="${product.variant}"
            data-product-url="${product.url}"
          ></button>
          <div class="fp-collections-social-count" data-product-id="${product.id}">${product?.social_count || ""}</div>
        </div>
      </div>`
      : `<div class="fp-follow-icon-button">
        <button
          aria-label="Add to Wishlist"
          name="add-to-wishlist"
          data-product-name="${product.title}"
          data-with-epi="true"
          class="swym-button swym-add-to-wishlist-view-product product_${product.id} swym-loaded swym-icon swym-heart"
          data-swaction="addToWishlist"
          data-product-id="${product.id}"
          data-variant-id="${product.variant}"
          data-product-url="${product.url}"
          ${!isLoggedIn ? "data-no-user" : ""}
        ></button>
        <div class="fp-collections-social-count" data-product-id="${product.id}">${product?.social_count || ""}</div>
      </div>`;

  return wrap`
    <div class="card-wrapper product-card-wrapper${isFollowingPage ? " fp-following-card" : ""}" id="${product.id}">
      ${wishlistButton}
      <div
        class="fp-algolia-product-card ais-hit ais-product card card--standard card--media"
        data-algolia-index="${algoliaData?.index ?? ""}"
        data-algolia-position="${algoliaData?.productPosition ?? ""}"
        data-algolia-queryid="${algoliaData?.queryID ?? ""}"
        data-algolia-objectid="${algoliaData?.objectID ?? ""}"
        data-handle="${algoliaData?.handle ?? ""}"
        data-variant-id="${algoliaData?.objectID ?? ""}"
        data-distinct="${algoliaData?._distinct ?? ""}"
        data-product-id="${algoliaData?.id ?? ""}"
        onClick="${onClick}"
      >
        <div class="fp-image-badge-wrapper">
          <a href="${product.url}" title="View ${product.title}" class="fp-image-wrapper" tabindex="-1" aria-hidden="true">
            <img
              class="ais-hit--picture fp-injected-primary-image"
              src="${getPrimaryImage(product)}"
              variant="${product.variant}"
              alt="${product.alt || product.title}"
              loading=${algoliaData.__position > 4 ? "lazy" : "eager"}
              fetchpriority=${algoliaData.__position <= 4 ? "high" : "auto"}
            />
            <img
              class="ais-hit--picture fp-injected-secondary-image"
              src="${getSecondaryImageByProduct(product)}"
              data-product-handle="${product.handle}"
              alt="${product.alt || product.title}"
              loading="lazy"
            />
          </a>
          <div class="fp-injected-badges ${badgesConfig.position}" data-product-handle="${product.handle}">${injectBadges(product, algoliaData, html)}</div>
        </div>

        <div class="card__content underline-links-hover">
          <div class="ais-hit--details card__information">
            <h3 class="ais-hit--title fp-title card__heading">
              <span class="fp-card__vendor">${product.vendor}</span>
              <a
                data-algolia-index="${algoliaData?.index ?? ""}"
                data-algolia-position="${algoliaData?.productPosition ?? ""}"
                data-algolia-queryid="${algoliaData?.queryID ?? ""}"
                data-algolia-objectid="${algoliaData?.objectID ?? ""}"
                href="${product.url}"
                class="full-unstyled-link fp-card__link"
              >
                <span class="fp-card__link__product-name">${product.title}</span>
              </a>
            </h3>
            <div class="card__information">
              ${
                product.condition
                  ? wrap`<p class="fp-condition left"><span class="fp-condition-label fp-condition-label--mobile">Cond: </span><span class="fp-condition-label fp-condition-label--desktop">Condition: </span>${INJECTED_CARD_CONDITION_LABEL_OVERRIDES[product.condition] ?? product.condition}</p>`
                  : ""
              }
            </div>
            ${
              shouldHidePrice
                ? ""
                : wrap`<div class="price price--on-sale" data-product-handle="${product.handle}">
                  <div class="price__container">
                    <div class="price__sale">
                      <div class="fp-price-items">
                        <span class="price-item price-item--sale price-item--last">
                          ${currencySymbol + price.toLocaleString("en-US")}
                        </span>
                        ${
                          compareAtPrice > price
                            ? wrap`<span><s class="price-item price-item--regular">
                            ${currencySymbol + compareAtPrice.toLocaleString("en-US")}</s></span>`
                            : ""
                        }
                      </div>
                      ${
                        compareAtPrice > price
                          ? wrap`<span class="fp-badge fp-badge--pink">${salePercentOff}% off</span>`
                          : ""
                      }
                    </div>
                  </div>
                  ${
                    retailPercentOff > 0
                      ? wrap`<div class="fp-retail-discount">
                          <span class="fp-retail-discount__label">Est. Retail ${currencySymbol + retailPrice.toLocaleString("en-US")}</span>
                          <span class="fp-badge fp-badge--green">${retailPercentOff}% below retail</span>
                        </div>`
                      : ""
                  }
                </div>`
            }
            ${saleMessage ? wrap`<p class="fp-sale-message">${renderSaleMessage(wrap, saleMessage)}</p>` : ""}
          </div>
        </div>
        ${
          isFollowingPage
            ? isProductSoldOut || hasHoldStatus
              ? findAnotherButton
              : isInCart
                ? productInBagWarning
                : addToBagButton
            : ""
        }
      </div>
    </div>
  `;
}

// Mobile carousel initialization
const MOBILE_BREAKPOINT = "(max-width: 767px)";
const MAX_CAROUSEL_IMAGES = 3;
const SWIPE_THRESHOLD_PX = 5;
const SCROLL_END_DELAY_MS = 60;

let activeDragTrack = null;
let dragStartX = 0;
let dragStartScrollLeft = 0;

document.addEventListener("mousemove", (e) => {
  if (!activeDragTrack) return;
  const dx = e.pageX - dragStartX;
  activeDragTrack.scrollLeft = dragStartScrollLeft - dx;
});

document.addEventListener("mouseup", () => {
  if (!activeDragTrack) return;
  const track = activeDragTrack;
  activeDragTrack = null;
  track.style.cursor = "";
  track.style.scrollSnapType = "";
  const w = track.closest(".fp-mobile-carousel").getBoundingClientRect().width;
  if (w > 0) {
    const nearest = Math.round(track.scrollLeft / w);
    track.scrollTo({ left: nearest * w, behavior: "smooth" });
  }
});

function initCarousel(carousel) {
  if (carousel.dataset.initialized) return;
  carousel.dataset.initialized = "true";

  const track = carousel.querySelector(".fp-mobile-carousel__track");
  const container = carousel.closest(".fp-mobile-carousel-container");
  const indicatorActive = container
    ? container.querySelector(".fp-mobile-carousel__indicator-active")
    : carousel.querySelector(".fp-mobile-carousel__indicator-active");
  const slideCount = parseInt(carousel.dataset.slideCount);

  if (!track || !indicatorActive || slideCount < 2) return;

  function getSlideWidth() {
    return carousel.getBoundingClientRect().width;
  }

  function setInitialPosition() {
    const w = getSlideWidth();
    if (w > 0) {
      track.style.scrollBehavior = "auto";
      track.scrollLeft = w;
      track.style.scrollBehavior = "";
      indicatorActive.style.transform = "translateX(0%)";
    }
  }

  let lastKnownIndex = 0;
  let isJumping = false;

  function updateIndicator(realPos) {
    const clampedPos = Math.max(0, Math.min(slideCount - 1, realPos));
    indicatorActive.style.transform = `translateX(${clampedPos * 100}%)`;
  }

  function jumpIfOnClone() {
    if (isJumping) return;
    const w = getSlideWidth();
    if (w === 0) return;

    const currentSnap = Math.round(track.scrollLeft / w);
    if (currentSnap <= 0 || currentSnap >= slideCount + 1) {
      isJumping = true;

      // Disable all browser scroll behavior before jumping
      track.style.scrollSnapType = "none";
      track.style.scrollBehavior = "auto";
      track.style.overflow = "hidden";

      if (currentSnap <= 0) {
        track.scrollLeft = slideCount * w;
        lastKnownIndex = slideCount - 1;
        updateIndicator(slideCount - 1);
      } else {
        track.scrollLeft = w;
        lastKnownIndex = 0;
        updateIndicator(0);
      }

      // Re-enable after browser commits the new position
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          track.style.overflow = "";
          track.style.scrollSnapType = "";
          track.style.scrollBehavior = "";
          isJumping = false;
        });
      });
    }
  }

  let scrollEndTimer;
  track.addEventListener("scroll", () => {
    if (isJumping) return;
    const w = getSlideWidth();
    if (w === 0) return;

    const rawPos = track.scrollLeft / w;
    const realPos = rawPos - 1;

    // When scrolling into a clone, immediately show the destination position
    let indicatorPos;
    if (realPos < 0) {
      indicatorPos = slideCount - 1;
    } else if (realPos > slideCount - 1) {
      indicatorPos = 0;
    } else {
      indicatorPos = realPos;
      lastKnownIndex = Math.round(realPos);
    }
    updateIndicator(indicatorPos);

    clearTimeout(scrollEndTimer);
    scrollEndTimer = setTimeout(jumpIfOnClone, SCROLL_END_DELAY_MS);
  });

  // Use scrollend for more reliable detection on modern browsers
  track.addEventListener("scrollend", jumpIfOnClone);

  track.addEventListener("mousedown", (e) => {
    activeDragTrack = track;
    dragStartX = e.pageX;
    dragStartScrollLeft = track.scrollLeft;
    track.style.scrollSnapType = "none";
    track.style.cursor = "grabbing";
    e.preventDefault();
  });

  // Prevent card link click from firing when interacting with carousel
  let touchStartX = 0;
  let isSwiping = false;

  track.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.touches[0].clientX;
      isSwiping = false;
    },
    { passive: true },
  );

  track.addEventListener(
    "touchmove",
    (e) => {
      const dx = Math.abs(e.touches[0].clientX - touchStartX);
      if (dx > SWIPE_THRESHOLD_PX) isSwiping = true;
    },
    { passive: true },
  );

  carousel.addEventListener(
    "click",
    (e) => {
      if (isSwiping) {
        e.preventDefault();
        e.stopPropagation();
        isSwiping = false;
      }
    },
    true,
  );

  const mobileQuery = window.matchMedia(MOBILE_BREAKPOINT);
  let positionSet = false;

  function trySetPosition() {
    if (mobileQuery.matches && !positionSet && carousel.offsetWidth > 0) {
      setInitialPosition();
      positionSet = true;
    }
  }

  // Use ResizeObserver to detect when carousel gets a real width
  const resizeObserver = new ResizeObserver(() => {
    if (!positionSet) {
      trySetPosition();
      return;
    }
    if (mobileQuery.matches && carousel.offsetWidth > 0) {
      isJumping = true;
      const w = getSlideWidth();
      track.style.scrollSnapType = "none";
      track.style.scrollBehavior = "auto";
      track.style.overflow = "hidden";
      track.scrollLeft = (lastKnownIndex + 1) * w;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          track.style.overflow = "";
          track.style.scrollSnapType = "";
          track.style.scrollBehavior = "";
          isJumping = false;
        });
      });
    }
  });
  resizeObserver.observe(carousel);

  mobileQuery.addEventListener("change", () => {
    if (mobileQuery.matches) {
      positionSet = false;
      trySetPosition();
    }
  });

  trySetPosition();
}

const isSoldItemsPage = window.location.pathname.includes("/collections/sold-items");

// Lazy-load carousels: only process cards when they enter (or are near) the viewport
const lazyCarouselObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      lazyCarouselObserver.unobserve(el);

      if (el.classList.contains("fp-mobile-carousel") && !el.dataset.initialized) {
        initCarousel(el);
      } else if (el.classList.contains("fp-algolia-product-card") && !el.dataset.carouselProcessed) {
        prioritizeProduct(el.dataset.handle);
        processCardForCarousel(el);
      } else if (el.classList.contains("product-card-wrapper") && !el.dataset.carouselProcessed && isSoldItemsPage) {
        processCardProductForCarousel(el);
      }
    });
  },
  { rootMargin: "200px" },
);

function observeCarouselCandidates() {
  document.querySelectorAll(".fp-mobile-carousel:not([data-initialized])").forEach((el) => {
    lazyCarouselObserver.observe(el);
  });
  document.querySelectorAll(".fp-algolia-product-card:not([data-carousel-processed])").forEach((el) => {
    lazyCarouselObserver.observe(el);
  });

  if (isSoldItemsPage) {
    document.querySelectorAll(".product-card-wrapper:not([data-carousel-processed])").forEach((el) => {
      lazyCarouselObserver.observe(el);
    });
  }
}

const carouselObserver = new MutationObserver((mutations) => {
  let hasNew = false;
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (
        node.classList?.contains("fp-algolia-product-card") ||
        node.classList?.contains("fp-mobile-carousel") ||
        node.classList?.contains("product-card-wrapper") ||
        (node.querySelector &&
          (node.querySelector(".fp-algolia-product-card") ||
            node.querySelector(".fp-mobile-carousel") ||
            node.querySelector(".product-card-wrapper")))
      ) {
        hasNew = true;
        break;
      }
    }
    if (hasNew) break;
  }
  if (hasNew) requestAnimationFrame(observeCarouselCandidates);
});

if (document.body) {
  carouselObserver.observe(document.body, { childList: true, subtree: true });
}

observeCarouselCandidates();
